<template>
<div class="chapter">
<div class="inner_page">
<h1 class="head" id="toc">CONTENTS</h1>
<p class="toc"><a href="#/OEBPS/ack.htm">Acknowledgments</a></p>
<p class="toc"><a href="#/OEBPS/fm1.htm">Welcome to Our Kitchen</a></p>
<p class="toc"><a href="#/OEBPS/c01.htm">Breakfast for Dinner</a></p>
<p class="toc"><a href="#/OEBPS/c02.htm">One-Pot Wonders</a></p>
<p class="toc"><a href="#/OEBPS/c03.htm">A Big Pot of Whole Grains</a></p>
<p class="toc"><a href="#/OEBPS/c04.htm">Stir-Fries</a></p>
<p class="toc"><a href="#/OEBPS/c05.htm">Rice and Beans</a></p>
<p class="toc"><a href="#/OEBPS/c06.htm">A Big Bowl of Pasta</a></p>
<p class="toc"><a href="#/OEBPS/c07.htm">The Meat Chapter</a></p>
<p class="toc"><a href="#/OEBPS/c08.htm">Breaking Down a Chicken</a></p>
<p class="toc"><a href="#/OEBPS/c09.htm">Fire Up the Grill</a></p>
<p class="toc"><a href="#/OEBPS/c10.htm">Buffets</a></p>
<p class="toc"><a href="#/OEBPS/c11.htm">Sweetness at the End of the Evening</a></p>
<p class="toc"><a href="#/OEBPS/res.htm">Resources</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?52fe547c